export default __webpack_public_path__ + "public/assets/images/97fc2f9ff97338ad2505ba43a188967e.png";